<template>
  <div id="swagger"></div>
</template>

<script>
import SwaggerUI from "swagger-ui";

export default {
  name: "Swagger",
  methods: {
    run() {
      SwaggerUI({
        url: "../swagger.json",
        dom_id: "#swagger",
      });
    },
  },
  mounted() {
    this.run();
  },
};
</script>

<style scoped>
@import "../../node_modules/swagger-ui/dist/swagger-ui.css";
</style>